import React from 'react';
import RewardMechanismStep from './RewardMechanismStep';
import RewardConfigStep from './RewardConfigStep';
import ProgressBarForm from './ProgressBarForm';
import StampStyleForm from './StampStyleForm';
import { generateStampsArray } from '@/config/cardTemplates';

const RewardForm = ({ formData, onUpdate, plan, currentStep, onStepChange, onFileChange, handleTextElementChange }) => {

  // Add useEffect to handle stamp initialization when threshold changes
  React.useEffect(() => {
    if (formData.rewardStyle === 'stamps' &&  formData.threshold > 0 ) {
      if (formData.rewardType === 'free-item' && formData.rewardQty > 0) {
        onUpdate({
          ...formData,
          stamps: generateStampsArray(formData.threshold, formData.rewardQty),
        });
      }
      else
      {
        onUpdate({
          ...formData,
          stamps: generateStampsArray(formData.threshold),
        });
      }
    }
  }, [formData.threshold, formData.rewardStyle, formData.rewardQty, formData.rewardType]);


  return (
    <div>
      {currentStep === 1 && (
        <RewardMechanismStep
          plan={plan}
          selected={formData.rewardMechanism}
          formData={formData}
          onUpdate={onUpdate}
          onNext={() => onStepChange(currentStep + 1)}
        />
      )}
      {currentStep === 2 && (
        <RewardConfigStep
          plan={plan}
          formData={formData}
          onUpdate={onUpdate}
          onBack={() => onStepChange(currentStep - 1)}
          onNext={() => onStepChange(currentStep + 1)}
        />
      )}
      {currentStep === 3 && (
        formData.rewardStyle === 'progress' ? (
          <ProgressBarForm
            styles={formData.progressBarStyles}
            formData={formData}
            onUpdate={(newStyles) => onUpdate({
              ...formData,
              progressBarStyles: newStyles
            })}
            onTextChange={handleTextElementChange}
            onBack={() => onStepChange(2)}
          />
        ) : (
          <StampStyleForm
            styles={formData}
            containerStyles={formData.stampContainerStyles}
            onUpdate={onUpdate}
            formData={formData}
            onTextChange={handleTextElementChange}
            onBack={() => onStepChange(2)}
            plan={plan}
            onFileChange={onFileChange}
          />
        )
      )}
    </div>
  );
};

export default RewardForm;
